import { createSelector } from 'reselect';
import { filter, orderBy, flow, reduce } from 'lodash/fp';

const threadsSelector = commentary => commentary.threads;
const filterSelector = (commentary, predicate) => predicate;

/**
 * Filter threads by a predicate
 * @param {object|func} predicate - function/object invoked per iteration
 * @param {object} commentary - commentary portion of the state
 * @return {array} - filtred threads as an array
 */
export const getFilteredThreads = createSelector(
  [threadsSelector, filterSelector],
  (threads, predicate) =>
    flow(filter(predicate), orderBy('id', 'desc'))(threads),
);

/**
 * Get comment counts for the current element commentary
 * @type {object} commentary - commentary portion of the state
 * @return {integer} - comments count
 */
export const getCommentsCount = createSelector([threadsSelector], threads => {
  const getCount = reduce((sum, n) => n.comments.length + sum, 0);
  return getCount(threads);
});
